import React, { useState } from "react";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import RemitterAccountViewAll from "../../../../containers/Accounts/RemitterAccount/RemitterAccountViewAll";
import ICONS from "../../../../assets/Icons";
import SmallPopup from "../../../_utils/CommonSmallPopup";
import { useNavigate } from "react-router-dom";

const RemitAccountViewAllPopup = (props) => {
  const navigate = useNavigate();
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    props?.closePopup(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  return (
    <>
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle="Open in full view?"
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext="Leaving this page will exit you from current flow."
            btnOneText="Cancel"
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <LargePopupRedirect
        headerTitle={props?.headerTitle}
        headersubtext={props?.headersubtext}
        closeiconenabledBgColor="var(--primary-nav)"
        closeiconisLoading={false}
        closeiconhandleFunction={() => props?.closePopup(false)}
        closeicon={ICONS?.CLOSE}
        closeiconhoverOption="white"
        closeiconbtnType={"button"}
        closeiconisDisabled={false}
        closeicondisabledBgColor={""}
        closeiconbuttonRef={null}
        closeicontitle={"Close"}
        btnType={"button"}
        enabledBgColor={"var(--negative-act)"}
        hoverOption={"dark"}
        outLineColor={""}
        enabledTextColor={"var(--text-primary)"}
        isDisabled={false}
        disabledTextColor={""}
        disabledBgColor={""}
        fullWidthRequired={true}
        isbottomSectionneed={props?.showModalPopup}
        bottomHeaderTextNeed={true}
        bottomHeaderText={props?.bottomHeaderText}
        confirmbtnrequired={props?.showModalPopup}
        btnText={props?.btnText}
        isDisabled={props?.createDisabled}
        isLoaderNeeded={true}
        isLoading={props?.createDisabled}
        enabledBgColor={"var(--positive-act)"}
        enabledTextColor={"var(--text-primary)"}
        disabledBgColor={
          props?.createDisabled ? "var(--positive-act)" : "var(--text-disabled)"
        }
        disabledTextColor={"var(--text-primary)"}
        outLineColor={""}
        hoverOption={"dark"}
        handleFunction={props?.handleConfirmBtnClick}
      >
        <RemitterAccountViewAll
          id={props?.id}
          remName={props?.remName}
          type={props?.type}
          onCardNavigate={
            props?.onCardNavigate ? handleCardNavigate : undefined
          }
          cardType={props?.cardType}
        />
      </LargePopupRedirect>
    </>
  );
};

export default RemitAccountViewAllPopup;
